// src/constants/companyInfo.js
// Circuit Printing ka billing information — admin panel se dynamically load hota hai
// MySQL API: siteSettings/socialDetails

import { doc, getDoc } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";

// Backup defaults if the settings API is unavailable
const DEFAULTS = {
  name: "Circuit Printing Solutions",
  email: "billing@circuitprinting.com",
  phone: "+1 (555) 123-4567",
  address: "123 Printing Lane",
  city: "Toronto",
  state: "ON",
  postcode: "M1A 1A1",
  country: "Canada",
  taxId: "805336690 RT0001",
};

let cachedInfo = null;

// Load company info from the admin panel
export async function loadCompanyInfo() {
  // Return cache agar available hai
  if (cachedInfo) return cachedInfo;

  try {
    const docSnap = await getDoc(doc(db, "siteSettings", "socialDetails"));
    if (docSnap.exists()) {
      const data = docSnap.data();
      cachedInfo = {
        name: data.name || DEFAULTS.name,
        email: data.email || DEFAULTS.email,
        phone: data.phone || DEFAULTS.phone,
        address: data.address || DEFAULTS.address,
        city: data.city || DEFAULTS.city,
        state: data.state || DEFAULTS.state, // Ya "province" ho sakta hai admin mein
        postcode: data.postcode || DEFAULTS.postcode,
        country: data.country || DEFAULTS.country,
        taxId: data.taxId || DEFAULTS.taxId,
      };
      console.log("[CompanyInfo] Loaded from admin panel:", cachedInfo);
      return cachedInfo;
    }
  } catch (err) {
    console.warn("[CompanyInfo] Could not load from Firestore, using defaults:", err);
  }

  // Fallback to defaults
  cachedInfo = DEFAULTS;
  return cachedInfo;
}

// Synchronous getter for checkout (jab async call possibility nahin ho)
// Ye cache ka use karega, already-loaded data return karega
export function getCompanyInfo() {
  if (!cachedInfo) {
    console.warn("[CompanyInfo] Cache empty, returning defaults. Call loadCompanyInfo() first.");
    return DEFAULTS;
  }
  return cachedInfo;
}

export const COMPANY_INFO = DEFAULTS;

export default COMPANY_INFO;
